import { render, staticRenderFns } from "./EmployeeBasicData.vue?vue&type=template&id=1592a5a5&"
import script from "./EmployeeBasicData.vue?vue&type=script&lang=js&"
export * from "./EmployeeBasicData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports